import { render, staticRenderFns } from "./GeneralButton.vue?vue&type=template&id=20cb2c02"
import script from "./GeneralButton.vue?vue&type=script&lang=js"
export * from "./GeneralButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports